export const postsData = [
  {
    id: 1,
    user: {
      avatar: '/assets/images/social/DDDD摆烂人.png',
      username: 'DDDD摆烂人',
      handle: 'up主线',
      verified: true
    },
    content: {
      text: '#DDDD#，#Gimme x Gimme#，#NM#，#歪狸#\n总之，这里是DDDD，我们想跳就跳！',
      images: ['/assets/images/social/gimme.png']
    },
    stats: {
      likes: 1112,
      comments: 45,
      shares: 23,
      bookmarks: 67
    },
    timestamp: '3小时前'
  },
  {
    id: 2,
    user: {
      avatar: '/assets/images/social/-946.png',
      username: '-946',
      handle: '@-946',
      verified: false
    },
    content: {
      text: '#游乐园#，#跳楼机#\n虽然说了老乡不骗老乡，可是我们不是老乡啊哈哈哈哈哈哈哈哈哈哈哈哈哈哈\n不会吧？真信了啊？',
      images: ['/assets/images/social/跳楼机.png']
    },
    stats: {
      likes: 6043,
      comments: 128,
      shares: 89,
      bookmarks: 234
    },
    timestamp: '5小时前'
  },
  {
    id: 3,
    user: {
      avatar: '/assets/images/social/G&K.png',
      username: 'G&K',
      handle: '中世纪线',
      verified: true
    },
    content: {
      text: '#机器人#，#改造#，#打印机#，#失败？#，#请勿随意改造机器人#\n改造不规范 亲人两行泪\n所以规范改造就可以了x\n按这个改造进度什么时候才能打谷子出来啊x两位机械师努努力啊努努力啊',
      images: ['/assets/images/social/保养液.png']
    },
    stats: {
      likes: 2856,
      comments: 92,
      shares: 156,
      bookmarks: 445
    },
    timestamp: '8小时前'
  },
  {
    id: 4,
    user: {
      avatar: '/assets/images/social/画不完了.png',
      username: '画不完了',
      handle: 'up主线',
      verified: true
    },
    content: {
      text: '#绘画的恐怖瞬间#，#文件过大#，#procreate崩溃#，#祈祷#\n天杀的一万块你就给我搞这出？？？\n真菜老师我懂你\n@呵 真菜',
      images: ['/assets/images/social/无法导入.png']
    },
    stats: {
      likes: 4521,
      comments: 203,
      shares: 156,
      bookmarks: 678
    },
    timestamp: '12小时前'
  },
  {
    id: 5,
    user: {
      avatar: '/assets/images/social/呵真菜.png',
      username: '呵真菜',
      handle: 'up主线',
      verified: false
    },
    content: {
      text: '#排版的恐怖瞬间#，#未响应#，#AI崩溃#，#AI是Adobe Illustrator#，#祈祷#\n已老实 求放过\n草草草草ai撑住啊你别崩溃啊你崩溃了我怎么办啊ai求求你了别崩溃啊\n我还没保存啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊',
      images: ['/assets/images/social/排版.png']
    },
    stats: {
      likes: 1876,
      comments: 87,
      shares: 45,
      bookmarks: 234
    },
    timestamp: '1天前'
  },
  {
    id: 6,
    user: {
      avatar: '/assets/images/social/向特么的阳而生.png',
      username: '向特么的阳而生',
      handle: 'up主线',
      verified: false
    },
    content: {
      text: '#谁说猫狗不合#，#狗狗#，#柯基#，#爱狗#\n啊啊啊啊啊啊啊啊啊啊啊狗狗不要怕嘿嘿嘿嘿让我好好ruarua嘿嘿嘿嘿嘿嘿嘿狗狗狗狗嘬嘬嘬————————————————————————',
      images: ['/assets/images/social/狗狗.png']
    },
    stats: {
      likes: 1876,
      comments: 87,
      shares: 45,
      bookmarks: 234
    },
    timestamp: '1天前'
  },{
    id: 7,
    user: {
      avatar: '/assets/images/social/Forever.png',
      username: 'Forever',
      handle: 'up主线',
      verified: false
    },
    content: {
      text: '#密室#，#鬼屋#，#怂货#，#一人带飞#，#carry全场#\nhuh？',
      images: ['/assets/images/social/鬼屋.png']
    },
    stats: {
      likes: 1876,
      comments: 87,
      shares: 45,
      bookmarks: 234
    },
    timestamp: '1天前'
  },{
    id: 8,
    user: {
      avatar: '/assets/images/social/画不完了.png',
      username: '画不完了',
      handle: 'up主线',
      verified: false
    },
    content: {
      text: '#DDDD#，#N#，#吃谷#\n所以那哥们到底凭什么可以放N旁边啊凭什么啊我都没在旁边凭什么啊凭什么凭什么凭什么！！！！！！！！！！！！！！',
      images: ['/assets/images/social/n.png']
    },
    stats: {
      likes: 1876,
      comments: 87,
      shares: 45,
      bookmarks: 234
    },
    timestamp: '1天前'
  },{
    id: 9,
    user: {
      avatar: '/assets/images/social/Sayakll.png',
      username: 'Sayakll',
      handle: 'up主线',
      verified: false
    },
    content: {
      text: '#DDDD#，#酒喵#，#女明星#，#吧唧#，#吃谷#，#调价#\n怎么调价高了点哎我推还是烫的不愧是大明星嗯嗯嗯嗯可是又要多花钱诶算了预支点工资吃了吧冲冲冲冲我吃我吃我吃我吃我吃',
      images: ['/assets/images/social/酒喵.png']
    },
    stats: {
      likes: 1876,
      comments: 87,
      shares: 45,
      bookmarks: 234
    },
    timestamp: '1天前'
  },{
    id: 10,
    user: {
      avatar: '/assets/images/social/画不完了.png',
      username: '画不完了',
      handle: 'up主线',
      verified: false
    },
    content: {
      text: '#DDDD#，#单推人#，#N#，#吧唧#，#吃谷#，#调价#\n我靠凭什么N调价那么低凭什么凭什么？白发暴调有什么依据吗凭什么啊！yue堵车一小时真的好晕车啊但是气抖冷真的没有人推N吗但是无所谓N的销量由我来承包！',
      images: ['/assets/images/social/单推人.png']
    },
    stats: {
      likes: 1876,
      comments: 87,
      shares: 45,
      bookmarks: 234
    },
    timestamp: '1天前'
  },{
    id: 10,
    user: {
      avatar: '/assets/images/social/呵真菜.png',
      username: '呵 真菜',
      handle: 'up主线',
      verified: false
    },
    content: {
      text: '#DDDD#，#堵车#，#吧唧#，#吃谷#，#调价#\nOK,fine也就是堵车了一个小时罢了区区一个小时啊yue真的好晕啊为什么要堵那么久啊哈哈哈哈我们精神状态很好啊哈哈哈哈哈哈刚好调个价罢了白发某人真的好烫啊怒调怒调暴调暴调',
      images: ['/assets/images/social/堵车.png']
    },
    stats: {
      likes: 1876,
      comments: 87,
      shares: 45,
      bookmarks: 234
    },
    timestamp: '1天前'
  },{
    id: 11,
    user: {
      avatar: '/assets/images/social/Double.png',
      username: 'Double D Rhythm工作室',
      handle: '娱乐圈线',
      verified: true,
    },
    content: {
      text: '#Double D Rhythm#，#专辑#，#发布#，#破晓歧点#\n新专即将发布，请多多支持',
      images: ['/assets/images/social/专辑.png']
    },
    stats: {
      likes: 1876,
      comments: 87,
      shares: 45,
      bookmarks: 234
    },
    timestamp: '1天前'
  }
  ,{
    id: 12,
    user: {
      avatar: '/assets/images/social/dd.png',
      username: 'Dazzling Divas',
      handle: '娱乐圈线',
      verified: true
    },
    content: {
      text: '#Dazzling Divas#，#女团#，#发布#，#练习室#\n新概念女团上线，成员们练习室合影公布！',
      images: ['/assets/images/social/女团.png']
    },
    stats: {
      likes: 1876,
      comments: 87,
      shares: 45,
      bookmarks: 234
    },
    timestamp: '1天前'
  }
  ,{
    id: 13,
    user: {
      avatar: '/assets/images/social/我魔法书呢.png',
      username: '我魔法书呢',
      handle: '中世纪线',
      verified: false
    },
    content: {
      text: '#探险#，#水陆空三用战甲#\n启程！',
      images: ['/assets/images/social/探险.png']
    },
    stats: {
      likes: 1876,
      comments: 87,
      shares: 45,
      bookmarks: 234
    },
    timestamp: '1天前'
  }
  ,{
    id: 14,
    user: {
      avatar: '/assets/images/social/火力覆盖.png',
      username: '火力覆盖',
      handle: '中世纪线',
      verified: false
    },
    content: {
      text: '#探险#，#遗迹#，#材料#\n发现了新遗迹，收获满满',
      images: ['/assets/images/social/遗迹.png']
    },
    stats: {
      likes: 1876,
      comments: 87,
      shares: 45,
      bookmarks: 234
    },
    timestamp: '1天前'
  },{
    id: 15,
    user: {
      avatar: '/assets/images/social/画不完了.png',
      username: '画不完了',
      handle: 'up主线',
      verified: false
    },
    content: {
      text: '#游乐园#，#过山车#，#危险行为 请勿模仿#，#团建#\n久违的来游乐园玩过山车，但是有些人真的不行吧哈哈哈哈哈哈哈哈哈',
      images: ['/assets/images/social/过山车.png']
    },
    stats: {
      likes: 1876,
      comments: 87,
      shares: 45,
      bookmarks: 234
    },
    timestamp: '1天前'
  },{
    id: 16,
    user: {
      avatar: '/assets/images/social/好想睡大觉.png',
      username: '好想睡大觉',
      handle: '宝可梦线',
      verified: true
    },
    content: {
      text: '#宝可梦#，#团建#，#踏青#，#手账#，#日常#\n大家一起玩看上去真的好棒呜呜呜，阿妈放心了大家能相处的那么好真的太好了',
      images: ['/assets/images/social/宝可梦.png']
    },
    stats: {
      likes: 1876,
      comments: 87,
      shares: 45,
      bookmarks: 234
    },
    timestamp: '1天前'
  },{
    id: 17,
    user: {
      avatar: '/assets/images/social/MSNoName.png',
      username: 'MSNoName',
      handle: '霍格沃茨线',
      verified: false
    },
    content: {
      text: '#练习#，#新技能#，#练习室#\n练习新技能',
      images: ['/assets/images/social/练习.png']
    },
    stats: {
      likes: 1876,
      comments: 87,
      shares: 45,
      bookmarks: 234
    },
    timestamp: '1天前'
  },{
    id: 18,
    user: {
      avatar: '/assets/images/social/酒喵2.png',
      username: '酒喵',
      handle: '宝可梦线',
      verified: false
    },
    content: {
      text: '#合照#，#宝可梦#\n是大合照——',
      images: ['/assets/images/social/合照.png']
    },
    stats: {
      likes: 1876,
      comments: 87,
      shares: 45,
      bookmarks: 234
    },
    timestamp: '1天前'
  }
];

export const rightSidebarData = [
  {
    id: 'worldview',
    title: '中世界热搜',
    items: [
      '一男子当街大明九夏被水师大人的…',
      '童子6合天才现！',
      '明对刀人害作能养',
      '街道上还很出现完主愿蔷',
      '魔法操界好吃呀？'
    ]
  },
  {
    id: 'entertainment',
    title: '娱乐圈热搜',
    items: [
      '某乐队成员搞出……',
      '姐妹谈高丽了？！',
      '搞到刚你不要再骂BIBIBAT！',
      '某小偶像当众宣布……',
      '厨房过现爆炸件？'
    ]
  },
  {
    id: 'up',
    title: 'UP主热搜',
    items: [
      'AI喷雾清洁',
      '审格DDDD成员精神状态',
      '搞到刚你不要再骂BIBIBAT！',
      '某来老师今天又抽疯了吗',
      '第了老师今天竟然来了吗'
    ]
  },
  {
    id: 'study',
    title: '学格求实热搜',
    items: [
      '特意公开主新',
      '学格求实新生入学',
      '童西建 场制爆炸',
      '飞天计算实全眼息',
      '买? 房简数!'
    ]
  },
  {
    id: 'game',
    title: '宝可梦热搜',
    items: [
      '新版本更新内容预览',
      '稀有宝可梦出现地点',
      '训练师对战技巧分享',
      '宝可梦进化条件解析',
      '最新活动奖励一览'
    ]
  }
]; 